<template>
  <div class="footer footer--dark">
    <div class="footer__content">
      <nav class="footer__navigation">
        <a
          class="footer__link"
          href="https://www.redbull.com/pp/ru_RU"
          target="_blank"
          >Положение о конфиденциальности</a
        >
        <a
          class="footer__link"
          href="https://www.redbull.com/tou/ru_RU"
          target="_blank"
          >Условия использования</a
        >
        <a
          class="footer__link"
          href="http://energydrink-ru.redbull.com/"
          target="_blank"
          >Продукты и компания</a
        >
        <a
          class="footer__link"
          href="https://www.redbull.com/im/ru_RU"
          target="_blank"
          >О компании</a
        >
        <a
          class="footer__link"
          href="https://www.redbull.com/bp/ru_RU"
          target="_blank"
          >Защита бренда</a
        >
        <a
          class="footer__link"
          href="https://www.redbullcontentpool.com/"
          target="_blank"
          >Медиа</a
        >
        <a
          class="footer__link"
          href="http://energydrink-ru.redbull.com/red-bull-rossiya-kontakti"
          target="_blank"
          >Связаться с нами</a
        >
        <a
          class="footer__link"
          href="https://www.redbullshop.com/en/?utm_campaign&#x3D;navi&amp;utm_source&#x3D;redbull.com&amp;utm_medium&#x3D;projects&amp;utm_content&#x3D;en&amp;wt_mc&#x3D;projects.redbull_com.navi"
          target="_blank"
          >Онлайн магазин</a
        >
        <a
          class="footer__link"
          href="http://jobs.redbull.com/ru/ru"
          target="_blank"
          >Работа в Red Bull</a
        >
      </nav>
      <div class="footer__copyright">© 2022 Red Bull</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
@lost gutter 10px;
@lost flexbox no-flex;
@font-face {
  font-family: "Bull Text";
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  src: url("https://resources.redbull.com/fonts/bull-text/v1/full/BullText-Regular.woff2")
      format("woff2"),
    url("https://resources.redbull.com/fonts/bull-text/v1/full/BullText-Regular.woff")
      format("woff");
}
@font-face {
  font-family: "Bull Text";
  font-weight: 500;
  font-style: normal;
  font-display: swap;
  src: url("https://resources.redbull.com/fonts/bull-text/v1/full/BullText-Medium.woff2")
      format("woff2"),
    url("https://resources.redbull.com/fonts/bull-text/v1/full/BullText-Medium.woff")
      format("woff");
}
@font-face {
  font-family: "Bull Text";
  font-weight: 700;
  font-style: normal;
  font-display: swap;
  src: url("https://resources.redbull.com/fonts/bull-text/v1/full/BullText-Bold.woff2")
      format("woff2"),
    url("https://resources.redbull.com/fonts/bull-text/v1/full/BullText-Bold.woff")
      format("woff");
}
body {
  margin: 0;
}
.footer {
  --font-family--text-default: "Bull Text";
  --font-family--title-default: "Bull Text";
  font-family: Helvetica, sans-serif;
  --font-family--title-fallback: Helvetica, sans-serif;
  --font-family--text-fallback: Helvetica, sans-serif;
  --font-family--japanese-regular: "Hiragino Kaku Gothic ProN W3",
    "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", Osaka, "メイリオ",
    "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Arial Unicode MS", Tahoma,
    Helvetica, sans-serif;
  --font-family--japanese-bold: "Hiragino Kaku Gothic StdN W8",
    "Hiragino Kaku Gothic Std", "Hiragino Kaku Gothic ProN W6", Osaka,
    "ヒラギノ角ゴ Std W8", "メイリオ", "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic",
    "Arial Unicode MS", Tahoma, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.fonts-loaded .footer,
.footer.fonts-loaded,
.footer .fonts-loaded {
  font-family: "Bull Text", Helvetica, sans-serif;
}
.fonts-loaded .footer,
.footer.fonts-loaded,
.footer .fonts-loaded {
  --font-family--title-default: Bull;
  --font-family--text-default: "Bull Text";
}
.footer:lang(ar) {
  font-family: Tahoma, "Arial Unicode MS", sans-serif;
  --font-family--title-fallback: Tahoma, "Arial Unicode MS", sans-serif;
  --font-family--text-fallback: Tahoma, "Arial Unicode MS", sans-serif;
}
.fonts-loaded .footer:lang(ar),
.footer:lang(ar).fonts-loaded,
.footer:lang(ar) .fonts-loaded {
  font-family: "Noto Kufi Arabic", Tahoma, "Arial Unicode MS", sans-serif;
}
.fonts-loaded .footer:lang(ar),
.footer:lang(ar).fonts-loaded,
.footer:lang(ar) .fonts-loaded {
  --font-family--title-default: "Noto Kufi Arabic";
  --font-family--text-default: "Noto Kufi Arabic";
}
.footer:lang(zh) {
  font-family: "Microsoft YaHei", "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro", "Hiragino Kaku Gothic ProN W3", Osaka,
    "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", "Arial Unicode MS",
    Tahoma, Helvetica, sans-serif;
  --font-family--title-fallback: "Microsoft YaHei", "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro", "Hiragino Kaku Gothic ProN W3", Osaka,
    "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", "Arial Unicode MS",
    Tahoma, Helvetica, sans-serif;
  --font-family--text-fallback: "Microsoft YaHei", "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro", "Hiragino Kaku Gothic ProN W3", Osaka,
    "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", "Arial Unicode MS",
    Tahoma, Helvetica, sans-serif;
}
.fonts-loaded .footer:lang(zh),
.footer:lang(zh).fonts-loaded,
.footer:lang(zh) .fonts-loaded {
  font-family: "Microsoft YaHei", "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro", "Hiragino Kaku Gothic ProN W3", Osaka,
    "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", "Arial Unicode MS",
    Tahoma, Helvetica, sans-serif;
}
.fonts-loaded .footer:lang(zh),
.footer:lang(zh).fonts-loaded,
.footer:lang(zh) .fonts-loaded {
  --font-family--title-default: "";
  --font-family--text-default: "";
}
.footer:lang(zh-Hant) {
  font-family: "Microsoft JhengHei", "Geneva CY", "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro", "Hiragino Kaku Gothic ProN W3", Osaka,
    "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", "Arial Unicode MS",
    Tahoma, Helvetica, sans-serif;
  --font-family--title-fallback: "Microsoft JhengHei", "Geneva CY",
    "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro",
    "Hiragino Kaku Gothic ProN W3", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック",
    "MS PGothic", "Arial Unicode MS", Tahoma, Helvetica, sans-serif;
  --font-family--text-fallback: "Microsoft JhengHei", "Geneva CY",
    "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro",
    "Hiragino Kaku Gothic ProN W3", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック",
    "MS PGothic", "Arial Unicode MS", Tahoma, Helvetica, sans-serif;
}
.fonts-loaded .footer:lang(zh-Hant),
.footer:lang(zh-Hant).fonts-loaded,
.footer:lang(zh-Hant) .fonts-loaded {
  font-family: "Microsoft JhengHei", "Geneva CY", "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro", "Hiragino Kaku Gothic ProN W3", Osaka,
    "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", "Arial Unicode MS",
    Tahoma, Helvetica, sans-serif;
}
.fonts-loaded .footer:lang(zh-Hant),
.footer:lang(zh-Hant).fonts-loaded,
.footer:lang(zh-Hant) .fonts-loaded {
  --font-family--title-default: "";
  --font-family--text-default: "";
}
.footer:lang(ko) {
  font-family: "Geneva CY", "NanumGothic", "MS PGothic", "Arial Unicode MS",
    Tahoma, Helvetica, sans-serif;
  --font-family--title-fallback: "Geneva CY", "NanumGothic", "MS PGothic",
    "Arial Unicode MS", Tahoma, Helvetica, sans-serif;
  --font-family--text-fallback: "Geneva CY", "NanumGothic", "MS PGothic",
    "Arial Unicode MS", Tahoma, Helvetica, sans-serif;
}
.fonts-loaded .footer:lang(ko),
.footer:lang(ko).fonts-loaded,
.footer:lang(ko) .fonts-loaded {
  font-family: "Geneva CY", "NanumGothic", "MS PGothic", "Arial Unicode MS",
    Tahoma, Helvetica, sans-serif;
}
.fonts-loaded .footer:lang(ko),
.footer:lang(ko).fonts-loaded,
.footer:lang(ko) .fonts-loaded {
  --font-family--title-default: "";
  --font-family--text-default: "";
}
.footer:lang(th) {
  font-family: Helvetica, Arial, "Thonburi", Tahoma, "Arial Unicode MS",
    sans-serif;
  --font-family--title-fallback: Helvetica, Arial, "Thonburi", Tahoma,
    "Arial Unicode MS", sans-serif;
  --font-family--text-fallback: Helvetica, Arial, "Thonburi", Tahoma,
    "Arial Unicode MS", sans-serif;
}
.fonts-loaded .footer:lang(th),
.footer:lang(th).fonts-loaded,
.footer:lang(th) .fonts-loaded {
  font-family: Helvetica, Arial, "Thonburi", Tahoma, "Arial Unicode MS",
    sans-serif;
}
.fonts-loaded .footer:lang(th),
.footer:lang(th).fonts-loaded,
.footer:lang(th) .fonts-loaded {
  --font-family--title-default: "";
  --font-family--text-default: "";
}
.footer:lang(ja) {
  font-family: "Hiragino Kaku Gothic ProN W3", "Hiragino Kaku Gothic Pro",
    "ヒラギノ角ゴ Pro W3", Osaka, "メイリオ", "Meiryo", "ＭＳ Ｐゴシック",
    "MS PGothic", "Arial Unicode MS", Tahoma, Helvetica, sans-serif;
  --font-family--title-fallback: "Hiragino Kaku Gothic ProN W3",
    "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", Osaka, "メイリオ",
    "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Arial Unicode MS", Tahoma,
    Helvetica, sans-serif;
  --font-family--text-fallback: "Hiragino Kaku Gothic ProN W3",
    "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", Osaka, "メイリオ",
    "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Arial Unicode MS", Tahoma,
    Helvetica, sans-serif;
}
.fonts-loaded .footer:lang(ja),
.footer:lang(ja).fonts-loaded,
.footer:lang(ja) .fonts-loaded {
  font-family: "Hiragino Kaku Gothic ProN W3", "Hiragino Kaku Gothic Pro",
    "ヒラギノ角ゴ Pro W3", Osaka, "メイリオ", "Meiryo", "ＭＳ Ｐゴシック",
    "MS PGothic", "Arial Unicode MS", Tahoma, Helvetica, sans-serif;
}
.fonts-loaded .footer:lang(ja),
.footer:lang(ja).fonts-loaded,
.footer:lang(ja) .fonts-loaded {
  --font-family--title-default: "";
  --font-family--text-default: "";
}
.footer__placeholder {
  visibility: hidden;
}
.footer--dark {
  background-color: #001e3c;
}
.footer--light {
  background-color: #fff;
}
.footer__content {
  max-width: 1350px;
  margin: 0 auto;
  font-family: var(--font-family--text-default, ""),
    var(--font-family--text-fallback);
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  padding: 30px 25px 50px 25px;
}
.footer__content:lang(ja) {
  --font-family--title-fallback: var(--font-family--japanese-bold, inherit);
  --font-family--text-fallback: var(--font-family--japanese-bold, inherit);
}
@media only screen and (min-width: 1000px) {
  .footer__content {
    padding: 30px 50px 50px 50px;
    flex-direction: row;
    justify-content: space-between;
  }
}
.footer__item,
.footer__link,
.footer__copyright {
  padding-top: 20px;
  text-align: center;
  text-transform: uppercase;
}
.footer__navigation {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-end;
}
@media only screen and (min-width: 1000px) {
  .footer__navigation {
    margin-left: 10px;
    flex-direction: row;
    order: 1;
  }
}
.footer__link {
  color: #fff;
  white-space: wrap;
  color: #fff;
}
.footer__link:visited {
  color: #fff;
}
.footer__link:active {
  color: #fff;
}
.footer__link:hover {
  color: #fff;
}
.footer__link,
.footer__link:visited,
.footer__link:active,
.footer__link:hover {
  text-decoration: none;
}
@media only screen and (min-width: 1000px) {
  .footer__link {
    white-space: nowrap;
    padding-left: 25px;
  }
}
.footer__link:hover {
  text-decoration: underline;
}
.footer--light .footer__link {
  color: #4d4e51;
}
.footer__copyright {
  color: #a0a1a1;
  white-space: nowrap;
}
.footer--light .footer__copyright {
  color: #4d4e51;
}
</style>
